import React from 'react';
import styled from 'styled-components';

const CompanyPageContainer = styled.div`
    margin-top: 16px;
    
    .main-table {
        margin-top: 10px;        
    }   
`;

export default CompanyPageContainer;